
    import { Component, Vue, Prop } from "vue-property-decorator";

    @Component({
    })
    export default class ConfirmMsgPopUp extends Vue {

        @Prop()
        msgValue: any;

        onConfirmClick() { this.$emit('confirmed'); }

        onCancelClick() { this.$emit('cancelled'); }
    }

